import { servicePropType }         from '../domain/service';
import { serviceCategoryPropType } from '../domain/serviceCategory';
import { serviceProviderPropType } from '../domain/serviceProvider';
import { serviceReviewPropType }   from '../domain/serviceReview';
import { serviceSubjectPropType }  from '../domain/serviceSubject';
import { shortlistPropType }       from '../domain/shortlist';
import { taxonomyPropType }        from '../domain/taxonomy';
import { taxonomyTermPropType }    from '../domain/taxonomyTerm';
import { userPropType }            from '../domain/user';

export const resourceNames = {
  SERVICE_CATEGORIES: 'serviceCategories',
  SERVICE_PROVIDERS:  'serviceProviders',
  SERVICE_REVIEWS:    'serviceReviews',
  SERVICES:           'services',
  SERVICE_SUBJECTS:   'serviceSubjects',
  SHORTLISTS:         'shortlists',
  TAXONOMIES:         'taxonomies',
  TAXONOMY_TERMS:     'taxonomyTerms',
  USERS:              'users',
};

export const exampleData = {
  [resourceNames.SERVICE_CATEGORIES]: {
    collection: {
      "@context":         "/contexts/ServiceCategories",
      "@id":              "/service_categories",
      "@type":            "hydra:Collection",
      'hydra:member':     [
        {
          '@id':   '/service_categories/1',
          '@type': 'http://schema.org/Thing',
          id:      '1',
          slug:    'care-and-support-for-adults',
          name:    'Care and support for adults',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/2',
          '@type': 'http://schema.org/Thing',
          id:      '2',
          slug:    'health-and-wellbeing',
          name:    'Health and Wellbeing',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/3',
          '@type': 'http://schema.org/Thing',
          id:      '3',
          slug:    'housing',
          name:    'Housing ',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/4',
          '@type': 'http://schema.org/Thing',
          id:      '4',
          slug:    'education-training-and-employment',
          name:    'Education, Training and Employment',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/5',
          '@type': 'http://schema.org/Thing',
          id:      '5',
          slug:    'assistance-at-home',
          name:    'Assistance at home',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/6',
          '@type': 'http://schema.org/Thing',
          id:      '6',
          slug:    'leisure-and-social',
          name:    'Leisure and Social',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/7',
          '@type': 'http://schema.org/Thing',
          id:      '7',
          slug:    'money-and-benefits',
          name:    'Money and Benefits',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/8',
          '@type': 'http://schema.org/Thing',
          id:      '8',
          slug:    'legal-including-immigration',
          name:    'Legal, including Immigration',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/9',
          '@type': 'http://schema.org/Thing',
          id:      '9',
          slug:    'family-and-personal-',
          name:    'Family and Personal  ',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/10',
          '@type': 'http://schema.org/Thing',
          id:      '10',
          slug:    'cultural',
          name:    'Cultural ',
          icon:    'fas:faUser',
        },
        {
          '@id':   '/service_categories/11',
          '@type': 'http://schema.org/Thing',
          id:      '11',
          slug:    'local-environment',
          name:    'Local environment ',
          icon:    'fas:faUser',
        },
      ],
      'hydra:totalItems': 32,
      'hydra:view':       {
        'hydra:first': '/service_categories?age=1',
        'hydra:next':  '/service_categories?page=2',
        'hydra:last':  '/service_categories?page=2',
      },
    },
    newItem:    {
      slug: 'fides-classis-et-capio',
      name: 'Fides, classis, et capio.',
      icon: 'fas:faUser',
    },
  },
  [resourceNames.SERVICE_PROVIDERS]:  {
    collection: {
      "@context":         "/contexts/ServiceProviders",
      "@id":              "/service_providers",
      "@type":            "hydra:Collection",
      'hydra:member':     [
        {
          '@id':       '/service_providers/1',
          '@type':     'http://schema.org/Organization',
          id:          '1',
          name:        'Ecce.',
          slug:        'ecce',
          description: null,
          email:       null,
          telephone:   null,
          logo:        null,
        },
        {
          '@id':       '/service_providers/2',
          '@type':     'http://schema.org/Organization',
          id:          '2',
          name:        'Eheu, devatio!',
          slug:        'eheu-devatio',
          description: null,
          email:       null,
          telephone:   null,
          logo:        null,
        },
        {
          '@id':       '/service_providers/3',
          '@type':     'http://schema.org/Organization',
          id:          '3',
          name:        'Vae, ventus!',
          slug:        'vae-ventus',
          description: null,
          email:       null,
          telephone:   null,
          logo:        null,
        },
      ],
      "hydra:totalItems": 3,
    },
    item:       {
      '@id':   '/service_providers/1',
      '@type': 'http://schema.org/Thing',
      id:      '1',
      slug:    'care-and-support-for-adults',
      name:    'Care and support for adults',
      icon:    'fas:faUser',
    },
    newItem:    {
      slug: 'fides-classis-et-capio',
      name: 'Fides, classis, et capio.',
      icon: 'fas:faUser',
    },
  },
  [resourceNames.SERVICE_SUBJECTS]:   {
    collection: {
      "@context":         "/contexts/ServiceSubject",
      "@id":              "/service_subjects",
      "@type":            "hydra:Collection",
      "hydra:member":     [
        {
          "@id":          "/service_subjects/acac4859-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acac4859-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Accessibility",
          "slug":         "accessibility",
          "serviceCount": 25,
        },
        {
          "@id":          "/service_subjects/acac8aae-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acac8aae-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Advocacy",
          "slug":         "advocacy",
          "serviceCount": 4,
        },
        {
          "@id":          "/service_subjects/acacd607-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acacd607-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Affordable Housing",
          "slug":         "affordable-housing",
          "serviceCount": 6,
        },
        {
          "@id":          "/service_subjects/acad21b2-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acad21b2-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Age UK Services",
          "slug":         "age-uk-services",
          "serviceCount": 5,
        },
        {
          "@id":          "/service_subjects/acad6b46-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acad6b46-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Arts and Crafts Groups",
          "slug":         "arts-and-crafts-groups",
          "serviceCount": 8,
        },
        {
          "@id":          "/service_subjects/acadac13-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acadac13-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Assistive Technology and Mobility Aids",
          "slug":         "assistive-technology-and-mobility-aids",
          "serviceCount": 8,
        },
        {
          "@id":          "/service_subjects/acadebce-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acadebce-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Befrienders",
          "slug":         "befrienders",
          "serviceCount": 10,
        },
        {
          "@id":          "/service_subjects/acae2e7d-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acae2e7d-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Befriending",
          "slug":         "befriending",
          "serviceCount": 4,
        },
        {
          "@id":          "/service_subjects/acae7d0d-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acae7d0d-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Benefits",
          "slug":         "benefits",
          "serviceCount": 6,
        },
        {
          "@id":          "/service_subjects/acaec404-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acaec404-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Bereavement",
          "slug":         "bereavement",
          "serviceCount": 3,
        },
        {
          "@id":          "/service_subjects/acaf0944-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acaf0944-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Black and Minority Ethnic Communities",
          "slug":         "black-and-minority-ethnic-communities",
          "serviceCount": 3,
        },
        {
          "@id":          "/service_subjects/acaf5399-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acaf5399-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Campaigning",
          "slug":         "campaigning",
          "serviceCount": 6,
        },
        {
          "@id":          "/service_subjects/acaf9560-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acaf9560-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Cancer",
          "slug":         "cancer",
          "serviceCount": 5,
        },
        {
          "@id":          "/service_subjects/acafd621-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acafd621-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Care Homes",
          "slug":         "care-homes",
          "serviceCount": 8,
        },
        {
          "@id":          "/service_subjects/acb019ee-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb019ee-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Carers Support",
          "slug":         "carers-support",
          "serviceCount": 7,
        },
        {
          "@id":          "/service_subjects/acb05a01-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb05a01-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Choir/Singing Group",
          "slug":         "choir-singing-group",
          "serviceCount": 7,
        },
        {
          "@id":          "/service_subjects/acb09bac-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb09bac-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Community Group",
          "slug":         "community-group",
          "serviceCount": 7,
        },
        {
          "@id":          "/service_subjects/acb0dbbf-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb0dbbf-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Complaints",
          "slug":         "complaints",
          "serviceCount": 3,
        },
        {
          "@id":          "/service_subjects/acb11bda-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb11bda-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Computer Classes",
          "slug":         "computer-classes",
          "serviceCount": 5,
        },
        {
          "@id":          "/service_subjects/acb15cf2-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb15cf2-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Computer Classes and Technical Support",
          "slug":         "computer-classes-and-technical-support",
          "serviceCount": 8,
        },
        {
          "@id":          "/service_subjects/acb19d8c-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb19d8c-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Consumer Support",
          "slug":         "consumer-support",
          "serviceCount": 8,
        },
        {
          "@id":          "/service_subjects/acb1e0ee-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb1e0ee-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Cookery Classes",
          "slug":         "cookery-classes",
          "serviceCount": 1,
        },
        {
          "@id":          "/service_subjects/acb22418-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb22418-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Counselling and Therapies",
          "slug":         "counselling-and-therapies",
          "serviceCount": 12,
        },
        {
          "@id":          "/service_subjects/acb264bf-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb264bf-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Day Centre",
          "slug":         "day-centre",
          "serviceCount": 12,
        },
        {
          "@id":          "/service_subjects/acb2a553-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb2a553-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Day Trips",
          "slug":         "day-trips",
          "serviceCount": 8,
        },
        {
          "@id":          "/service_subjects/acb2e5f2-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb2e5f2-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Dementia/Alzheimers",
          "slug":         "dementia-alzheimers",
          "serviceCount": 7,
        },
        {
          "@id":          "/service_subjects/acb32d01-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb32d01-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Dentists",
          "slug":         "dentists",
          "serviceCount": 6,
        },
        {
          "@id":          "/service_subjects/acb36fdf-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb36fdf-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Domestic Violence",
          "slug":         "domestic-violence",
          "serviceCount": 6,
        },
        {
          "@id":          "/service_subjects/acb3b37b-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb3b37b-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Emotional Support",
          "slug":         "emotional-support",
          "serviceCount": 8,
        },
        {
          "@id":          "/service_subjects/acb3f30b-7f9c-11e8-b0f8-0242c0a80002",
          "@type":        "http://schema.org/Thing",
          "id":           "acb3f30b-7f9c-11e8-b0f8-0242c0a80002",
          "name":         "Employment Advice",
          "slug":         "employment-advice",
          "serviceCount": 6,
        },
      ],
      "hydra:totalItems": 102,
      "hydra:view":       {
        "@id":         "/service_subjects?page=1",
        "@type":       "hydra:PartialCollectionView",
        "hydra:first": "/service_subjects?page=1",
        "hydra:last":  "/service_subjects?page=4",
        "hydra:next":  "/service_subjects?page=2",
      },
      "hydra:search":     {
        "@type":                        "hydra:IriTemplate",
        "hydra:template":               "/service_subjects{?id,id[],slug,slug[]}",
        "hydra:variableRepresentation": "BasicRepresentation",
        "hydra:mapping":                [
          {
            "@type":    "IriTemplateMapping",
            "variable": "id",
            "property": "id",
            "required": false,
          },
          {
            "@type":    "IriTemplateMapping",
            "variable": "id[]",
            "property": "id",
            "required": false,
          },
          {
            "@type":    "IriTemplateMapping",
            "variable": "slug",
            "property": "slug",
            "required": false,
          },
          {
            "@type":    "IriTemplateMapping",
            "variable": "slug[]",
            "property": "slug",
            "required": false,
          },
        ],
      },
    },
    item:       {
      "@context":     "/contexts/ServiceSubject",
      "@id":          "/service_subjects/acac4859-7f9c-11e8-b0f8-0242c0a80002",
      "@type":        "http://schema.org/Thing",
      "id":           "acac4859-7f9c-11e8-b0f8-0242c0a80002",
      "name":         "Accessibility",
      "slug":         "accessibility",
      "serviceCount": 25,
    },
    newItem:    {
      slug: 'olla-fortis-et-secula',
      name: 'Olla, fortis, et secula.',
    },
  },
  [resourceNames.SERVICES]:           {
    collection: {
      "@context":         "/contexts/Services",
      "@id":              "/services",
      "@type":            "hydra:Collection",
      'hydra:member':     [
        {
          '@id':        '/services/1',
          '@type':      'http://schema.org/Service',
          id:           '1',
          slug:         'ollas-unda-in-burdigala',
          name:         'Ollas unda in burdigala',
          description:  'Jolly roger, ye mighty shipmate- set sails for grace!',
          provider:     {
            '@id':       '/service_providers/1',
            '@type':     'http://schema.org/Organization',
            id:          '1',
            name:        'Ecce.',
            slug:        'ecce',
            description: null,
            email:       null,
            telephone:   null,
            logo:        null,
          },
          locations:    [{
            '@id':   '/services_locations/1',
            id:      '1',
            address: {},
          }],
          openingTimes: [],
          categories:   [],
          reviews:      [],
          createdAt:    '2018-03-03T08:12:09+00:00',
          updatedAt:    '2018-03-06T11:59:09+00:00',
        },
        {
          '@id':        '/services/2',
          '@type':      'http://schema.org/Service',
          id:           '2',
          slug:         'cum-amicitia-potus',
          name:         'Cum amicitia potus',
          description:  'When the moon travels for la marsa beach, all cockroachs mark clear, scurvy shores.',
          provider:     {
            '@id':       '/service_providers/2',
            '@type':     'http://schema.org/Organization',
            id:          '2',
            name:        'Eheu, devatio!',
            slug:        'eheu-devatio',
            description: null,
            email:       null,
            telephone:   null,
            logo:        null,
          },
          locations:    [{
            '@id':   '/services_locations/2',
            id:      '2',
            address: {},
          }],
          openingTimes: [],
          categories:   [],
          reviews:      [],
          createdAt:    '2017-01-12T12:37:52+00:00',
          updatedAt:    '2017-08-12T23:18:12+00:00',
        },
        {
          '@id':        '/services/3',
          '@type':      'http://schema.org/Service',
          id:           '3',
          slug:         'sunt-fluctuies-aperto-festus',
          name:         'Sunt fluctuies aperto festus',
          description:  'Cannons are the biscuit eaters of the undead endurance.',
          provider:     {
            '@id':       '/service_providers/3',
            '@type':     'http://schema.org/Organization',
            id:          '3',
            name:        'Vae, ventus!',
            slug:        'vae-ventus',
            description: null,
            email:       null,
            telephone:   null,
            logo:        null,
          },
          locations:    [{
            '@id':   '/services_locations/3',
            id:      '3',
            address: {},
          }],
          openingTimes: [],
          categories:   [],
          reviews:      [],
          createdAt:    '2018-03-01T12:45:23+00:00',
          updatedAt:    '2018-03-02T17:56:12+00:00',
        },
        {
          '@id':        '/services/4',
          '@type':      'http://schema.org/Service',
          id:           '4',
          slug:         'persuadere-saepe-ducunt',
          name:         'Persuadere saepe ducunt',
          description:  'Treasure ho! raid to be sailled.',
          provider:     {
            '@id':       '/service_providers/1',
            '@type':     'http://schema.org/Organization',
            id:          '1',
            name:        'Ecce.',
            slug:        'ecce',
            description: null,
            email:       null,
            telephone:   null,
            logo:        null,
          },
          locations:    [{
            '@id':   '/services_locations/4',
            id:      '4',
            address: {},
          }],
          openingTimes: [],
          categories:   [],
          reviews:      [],
          createdAt:    '2018-03-03T08:12:09+00:00',
          updatedAt:    '2018-03-06T11:59:09+00:00',
        },
        {
          '@id':        '/services/5',
          '@type':      'http://schema.org/Service',
          id:           '5',
          slug:         'pol,-alter-decor',
          name:         'Pol, alter decor',
          description:  'The lagoon hoists with life, command the freighter until it hobbles.',
          provider:     {
            '@id':       '/service_providers/1',
            '@type':     'http://schema.org/Organization',
            id:          '1',
            name:        'Ecce.',
            slug:        'ecce',
            description: null,
            email:       null,
            telephone:   null,
            logo:        null,
          },
          locations:    [{
            '@id':   '/services_locations/5',
            id:      '5',
            address: {},
          }],
          openingTimes: [],
          categories:   [],
          reviews:      [],
          createdAt:    '2018-03-03T08:12:09+00:00',
          updatedAt:    '2018-03-06T11:59:09+00:00',
        },
        {
          '@id':        '/services/6',
          '@type':      'http://schema.org/Service',
          id:           '6',
          slug:         'burguss-credere-in-mare!',
          name:         'Burguss credere in mare!',
          description:  'The scallywag rises yellow fever like a cloudy cannibal.',
          provider:     {
            '@id':       '/service_providers/2',
            '@type':     'http://schema.org/Organization',
            id:          '2',
            name:        'Eheu, devatio!',
            slug:        'eheu-devatio',
            description: null,
            email:       null,
            telephone:   null,
            logo:        null,
          },
          locations:    [{
            '@id':   '/services_locations/6',
            id:      '6',
            address: {},
          }],
          openingTimes: [],
          categories:   [],
          reviews:      [],
          createdAt:    '2018-03-03T08:12:09+00:00',
          updatedAt:    '2018-03-06T11:59:09+00:00',
        },
      ],
      "hydra:totalItems": 32,
      "hydra:view":       {
        "@id":         "/services?page=1",
        "@type":       "hydra:PartialCollectionView",
        "hydra:first": "/services?page=1",
        "hydra:next":  "/services?page=2",
        "hydra:last":  "/services?page=2",
      },
    },
    item:       {
      "@context":   "/contexts/Service",
      '@id':        '/services/99',
      '@type':      'http://schema.org/Service',
      id:           '99',
      slug:         'cum-mens-assimilant',
      name:         'Cum mens assimilant',
      description:  'Rainy, scurvy gulls smartly fight a dead, weird tobacco.',
      provider:     {
        '@id':       '/service_providers/1',
        '@type':     'http://schema.org/Organization',
        id:          '1',
        name:        'Ecce.',
        slug:        'ecce',
        description: null,
        email:       null,
        telephone:   null,
        logo:        null,
      },
      locations:    [
        {
          '@id':     '/service_locations/a48f7f52-1e1a-11e8-bfaa-0242c0a80003',
          '@type':   'http://schema.org/GeoCoordinates',
          id:        'a48f7f52-1e1a-11e8-bfaa-0242c0a80003',
          address:   {
            '@id':               '/service_location_addresses/a48f90ac-1e1a-11e8-bfaa-0242c0a80003',
            '@type':             'http://schema.org/PostalAddress',
            id:                  'a48f90ac-1e1a-11e8-bfaa-0242c0a80003',
            postOfficeBoxNumber: null,
            streetAddress:       '434 Ava Port',
            addressLocality:     'North Tanya',
            addressRegion:       null,
            postalCode:          'S81 0HT',
            addressCountry:      'UK',
          },
          latitude:  0.0982463384,
          longitude: 51.3886986155,
        },
      ],
      openingTimes: [],
      categories:   [],
      reviews:      [],
      createdAt:    '2018-03-03T08:12:09+00:00',
      updatedAt:    '2018-03-06T11:59:09+00:00',
    },
    newItem:    {
      slug:        'fides-classis-et-capio',
      name:        'Fides, classis, et capio.',
      description: 'When the lubber laughs for madagascar, all peglegs vandalize small, weird bucaneers.',
    },
  },
  [resourceNames.SHORTLISTS]:         {
    collection: {},
    item:       {
      '@context': 'context/Shortlist',
      '@id':      '/shortlists/1',
      '@type':    'http://schema.org/Thing',
      'id':       '1',
      'user':     {
        '@id': '/users/1',
      },
      'name':     'My shortlist',
      'services': '/shortlists/__local__/services',
    },
  },
  [resourceNames.USERS]:              {
    collection: {},
    item:       {
      "@context":       "/contexts/User",
      "@id":            "/users/dec04e2c-2615-11e8-81a3-0242c0a80002",
      "@type":          "http://schema.org/Person",
      "id":             "dec04e2c-2615-11e8-81a3-0242c0a80002",
      "givenName":      "Fred",
      "shortlists":     [
        "/shortlists/e4ca9348-2615-11e8-81a3-0242c0a80002",
      ],
      "serviceReviews": [],
    },
    ownItem:    {
      "@context":       "/contexts/User",
      "@id":            "/users/dec04e2c-2615-11e8-81a3-0242c0a80002",
      "@type":          "http://schema.org/Person",
      "id":             "dec04e2c-2615-11e8-81a3-0242c0a80002",
      "email":          "me@example.com",
      "givenName":      "Fred",
      "familyName":     "Bloggs",
      "shortlists":     [
        "/shortlists/e4ca9348-2615-11e8-81a3-0242c0a80002",
      ],
      "serviceReviews": [],
    },
  },
};


const blankTemplate = {
  id:   '__new__',
  slug: '__new__',
};

const serviceProviderBlankTemplate = Object.assign({}, blankTemplate, {
  "@context":  '/contexts/ServiceProvider',
  '@type':     'http://schema.org/Organization',
  '@id':       '/service_providers/__new__',
  name:        '',
  description: '',
  email:       '',
  telephone:   '',
  logo:        '',
});

const resourcesConfig = {

  [resourceNames.SERVICE_CATEGORIES]: {
    apiPath:  '/service_categories',
    singular: 'serviceCategory',
    plural:   'serviceCategories',
    propType: serviceCategoryPropType,

    testData: {...exampleData.serviceCategories},
  },

  [resourceNames.SERVICE_PROVIDERS]: {
    apiPath:       '/service_providers',
    singular:      'serviceProvider',
    plural:        'serviceProviders',
    propType:      serviceProviderPropType,
    blankTemplate: Object.assign({}, serviceProviderBlankTemplate),
  },

  [resourceNames.SERVICE_REVIEWS]: {
    apiPath:  '/service_reviews',
    singular: 'serviceReview',
    plural:   'serviceReviews',
    propType: serviceReviewPropType,
  },

  [resourceNames.SERVICE_SUBJECTS]: {
    apiPath:  '/service_subjects',
    singular: 'serviceSubject',
    plural:   'serviceSubjects',
    propType: serviceSubjectPropType,

    testData: {...exampleData[resourceNames.SERVICE_SUBJECTS]},
  },

  [resourceNames.SERVICES]: {
    apiPath:           '/services',
    singular:          'service',
    plural:            'services',
    propType:          servicePropType,
    collectionFilters: {categories: 'categories.slug', subjects: 'subjects.slug'},

    testData: {...exampleData[resourceNames.SERVICES]},
  },

  [resourceNames.SHORTLISTS]: {
    apiPath:  '/shortlists',
    singular: 'shortlist',
    plural:   'shortlists',
    propType: shortlistPropType,

    testData: {...exampleData.shortlists},
  },

  [resourceNames.TAXONOMIES]: {
    apiPath:  '/taxonomies',
    singular: 'taxonomy',
    plural:   'taxonomies',
    propType: taxonomyPropType,
  },

  [resourceNames.TAXONOMY_TERMS]: {
    apiPath:  '/taxonomy_terms',
    singular: 'taxonomy term',
    plural:   'taxonomy terms',
    propType: taxonomyTermPropType,
  },

  [resourceNames.USERS]: {
    apiPath:  '/users',
    singular: 'user',
    plural:   'users',
    propType: userPropType,
  },

};


const getConfig = (resource) => {

  if (!resourcesConfig[resource]) {

    throw new Error(
      `Invalid resource (${resource}).  Possible values are '${Object.keys(resourcesConfig).join("', '")}'`,
    );

  }

  return resourcesConfig[resource];

};


/**
 * Returns an API path for the given resource with the optional ID and path elements.
 *
 * @param {string} resource
 * @param {?string} id
 * @param {?string} subPath
 *
 * @return {string}
 */
export const getApiPath = (resource, {id = null, subPath = null} = {}) =>
  `${getConfig(resource).apiPath}${id ? `/${id}` : ''}${subPath ? `/${subPath}` : ''}`;


const resourcesEndpoints = Object.entries(resourcesConfig).reduce(
  (accumulator, [resource, resourceConfig]) => {

    accumulator[resource] = resourceConfig.apiPath;

    return accumulator;

  },

  {},
);

export default resourcesConfig;

export {
  getConfig,
  resourcesEndpoints,
};



// WEBPACK FOOTER //
// ./src/config/resources.config.js